// extracted by mini-css-extract-plugin
var _1 = "_z78cAByrF";
var _2 = "q4G7wDi_2p";
export { _1 as "disabled", _2 as "root" }
